module.exports = __webpack_public_path__ + "static/media/mediabg.f60b26c3.jpg";